import React, { FunctionComponent, useState, useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box } from '@mui/material';
import { ActiveMember, Role, UserRolesInput } from '../types/members-types';
import RolesAutocomplete from './RolesAutocomplete';

export interface UpdateUserRolesFormProps {
  member: ActiveMember;
  onAddRole: (userRolesInput: UserRolesInput) => void;
  onRemoveRole: (userRolesInput: UserRolesInput) => void;
  availableRoles: Role[];
}

const UpdateUserRolesForm: FunctionComponent<
  React.PropsWithChildren<UpdateUserRolesFormProps>
> = props => {
  const { classes } = useStyles();

  const { member, onAddRole, onRemoveRole, availableRoles } = props;
  const [selectedRoles, setSelectedRoles] = useState<Role[]>(member.roles);

  const handleOnChangeRole = useCallback(
    (newRoles: Role[]) => {
      if (newRoles.length > selectedRoles.length) {
        const addedRole = newRoles.filter(
          r => !selectedRoles.map(s => s.id).includes(r.id),
        );
        const userRolesInput: UserRolesInput = {
          userId: member.user_id,
          roleIDs: addedRole.map(a => a.id),
        };

        onAddRole(userRolesInput);
      } else {
        const removedRole = selectedRoles.filter(
          r => !newRoles.map(s => s.id).includes(r.id),
        );
        const userRolesInput: UserRolesInput = {
          userId: member.user_id,
          roleIDs: removedRole.map(a => a.id),
        };

        onRemoveRole(userRolesInput);
      }

      setSelectedRoles(newRoles);
    },
    [member, selectedRoles, onAddRole, onRemoveRole],
  );

  return (
    <form className={classes.rootForm}>
      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <RolesAutocomplete
          availableRoles={availableRoles}
          selectedRoles={selectedRoles}
          handleOnChangeRole={handleOnChangeRole}
        />
      </Box>
    </form>
  );
};

const useStyles = makeStyles()(() => ({
  rootForm: {
    width: '100%',
  },
}));

export default UpdateUserRolesForm;
